export default [
  {
    path: '/address/list',
    name: 'InvoiceAddress',
    meta: { title: '邮寄地址列表', noCard: true },
    component: () => import('@/views/Invoice/Address/List')
  },
  {
    path: '/address/input',
    name: 'InvoiceInput',
    meta: { title: '邮寄地址', noCard: true },
    component: () => import('@/views/Invoice/Address/Input')
  }
]
